import { useData } from "@hooks/useData";
import http from "@core/fetch";
import { components } from "@apiSchema";
import { ID } from "@models";

export type CategoryProfilePopularityTrendGap = components["schemas"]["SnapCategoryProfilePopularityTrendGapModel"];
export type PopularityTrendGapKeyword = components["schemas"]["SnapPopularityTrendGapKeyword"];

async function getCategoryProfilePopularityTrendGap(id: ID): Promise<CategoryProfilePopularityTrendGap[]> {
    const result: CategoryProfilePopularityTrendGap[] = await http.getXHR("get category profile popularity trend gap", { id });

    return result ?? [];
}

export default function useCategoryProfilePopularityTrendGap(id: ID) {
    return useData<CategoryProfilePopularityTrendGap[]>([], getCategoryProfilePopularityTrendGap, id);
}
